import { render, staticRenderFns } from "./EconomicGroupBlockAlert.vue?vue&type=template&id=eed5a3ea"
import script from "./EconomicGroupBlockAlert.vue?vue&type=script&lang=js"
export * from "./EconomicGroupBlockAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports